import { g as getNamedFormat, f as filterProps } from './utils-b0152686-02a2d19d.js';
import { a as IntlFormatError } from './error-9e87f495-aa7226e5.js';

var NUMBER_FORMAT_OPTIONS = ['style', 'currency', 'currencyDisplay', 'unit', 'unitDisplay', 'useGrouping', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits',
// ES2020 NumberFormat
'compactDisplay', 'currencyDisplay', 'currencySign', 'notation', 'signDisplay', 'unit', 'unitDisplay', 'numberingSystem'];
function getFormatter(_a, getNumberFormat, options) {
  var locale = _a.locale,
    formats = _a.formats,
    onError = _a.onError;
  if (options === void 0) {
    options = {};
  }
  var format = options.format;
  var defaults = format && getNamedFormat(formats, 'number', format, onError) || {};
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults);
  return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
  if (options === void 0) {
    options = {};
  }
  try {
    return getFormatter(config, getNumberFormat, options).format(value);
  } catch (e) {
    config.onError(new IntlFormatError('Error formatting number.', config.locale, e));
  }
  return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
  if (options === void 0) {
    options = {};
  }
  try {
    return getFormatter(config, getNumberFormat, options).formatToParts(value);
  } catch (e) {
    config.onError(new IntlFormatError('Error formatting number.', config.locale, e));
  }
  return [];
}

export { formatNumberToParts as a, formatNumber as f };
//# sourceMappingURL=number-82cca1bf-8c1f505b.js.map
